module.exports = __webpack_public_path__ + "media/assets/icons/badge-b31129de8ff3b599a88878fa33f9d8ce.svg";